<div id="labor-calendar-view" class="page-layout blank">
    <div class="content">
        <div class="title">
            <h2>Calendarios laborales (días festivos)</h2>
            <!-- <button mat-raised-button color="primary">Aceptar</button> -->
        </div>
        <div class="left">
            <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start">
                <div class="widget" fxFlex="100" fxFlex.gt-sm="20">
                    <app-holiday-list (treeViewData)="getDataEventHander($event)"></app-holiday-list>
                </div>
                <div class="widget" fxFlex="100" fxFlex.gt-sm="80">
                    <app-vacation-list *ngIf="isShowList" [getTreeViewData]="selectedData"></app-vacation-list>
                </div>
            </div>
        </div>
    </div> 
</div>